import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { getDataFromBOU,deleteData } from '../../Helpers/ApiMethodHelper';
import { axiosPrivate } from '../../Helpers/axios';
let agentId="12345605947539573"
function* ServiceDataResponse({ payload: { offset, limit, search, fromDate, toDate } }) {
  try {
    const response = yield call(axiosPrivate.get, `/api/dashboard/services?agentId=${agentId}&page=${offset ? offset : 1}&limit=${limit ? limit : 10}${search ? `&search=${search} ` : ''}${fromDate ? `&fromDate=${fromDate} ` : ''}${toDate ? `&toDate=${toDate} ` : ''}`);
    if (response.status === 200) {
      yield put(actions.getServiceDataSuccess(response.data?.service,response.data.total));
    } else {
      yield put(actions.getServiceDataFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getServiceDataFailed(error?.response?.data?.message));
  }
}

function* deleteServiceResponse({ payload: { id,status }}) {
  let body ={
    status
  }
  try {
    const response = yield call(axiosPrivate.patch, `/api/dashboard/services/isactive/${agentId}/${id}`,body);
    if (response.status === 200) {
      if(!response?.data?.isActive){
        yield put(actions.deleteServiceSuccess("Servce Deactive sucessfully"));
      }else{
        yield put(actions.deleteServiceSuccess("Servce Active sucessfully"));

      }
      // Dispatch GET_USER_DATA action to fetch updated data
      yield put(actions.getServiceData(0, 10));

    } else {
      yield put(actions.deleteServiceFailed(response.message));

    }
  } catch (error) {
    // yield put(actions.deleteServiceFailed(error));
    yield put(actions.deleteServiceFailed(error?.response?.data?.message));
  }
}

function* addServiceResponse({ payload: { data } }) {
  try {
    const response = yield call(axiosPrivate.post, `/api/dashboard/services/create`, data);
    if (response.status === 201) {
      yield put(actions.addServiceSuccess("Service added succcessfully"));
      // Dispatch GET_USER_DATA action to fetch updated data
      yield put(actions.getServiceData(0, 10));
    } else {
      yield put(actions.addServiceFailed(response.message));
    }
  } catch (error) {
    yield put(actions.addServiceFailed(error?.response?.data?.message));
  }
}



export default function* rootSaga() {
  yield all([takeEvery(actions.GET_SERVICE_DATA, ServiceDataResponse)]);
  yield all([takeEvery(actions.DELETE_SERVICE, deleteServiceResponse)]);
  yield all([takeEvery(actions.ADD_SERVICE, addServiceResponse)]);
 

}
